import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SessionRepository } from './state/session.repository';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserMenuComponent } from './user/user-menu/user-menu.component';
import { NgxMatDateAdapter, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { LanguageService } from './shared/services/language.service';
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';
import { AplicationSelectorComponent } from './aplication-selector/aplication-selector.component';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    UserMenuComponent,
    NgxMatNativeDateModule,
    MatDialogModule,
    ClickOutsideDirective,
    AplicationSelectorComponent,
  ],
})
export class AppComponent {
  title = 'derichebourg-msm-limpiezapp-dashboard';
  showUserProfile = false;
  showAppSelector = false;
  applicationName = 'Work Orders';

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private sessionRepository: SessionRepository,
    private languageService: LanguageService
  ) {
    this.languageService.setDefaultLanguage();

    this.msalBroadcastService.inProgress$
      .pipe(
        takeUntilDestroyed(),
        filter(
          (status: InteractionStatus) =>
            status === InteractionStatus.None || status === InteractionStatus.HandleRedirect
        )
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
    this.msalBroadcastService.msalSubject$
      .pipe(
        takeUntilDestroyed(),
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe((result) => {
        this.checkAndSetActiveAccount();
      });
  }

  private checkAndSetActiveAccount() {
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }

    activeAccount = this.msalService.instance.getActiveAccount();

    if (activeAccount) {
      this.sessionRepository.loadGraphUser();
    }
  }

  showCloseUserProfile(event: MouseEvent) {
    event.stopPropagation(); //dont call directive
    this.showAppSelector = false;
    this.showUserProfile = !this.showUserProfile;
  }

  showCloseAppSelector(event: MouseEvent) {
    event.stopPropagation();
    this.showUserProfile = false;
    this.showAppSelector = !this.showAppSelector;
  }

  closeUserProfile() {
    this.showUserProfile = false;
  }

  closeAppSelector() {
    this.showAppSelector = false;
  }
}
